import { render, staticRenderFns } from "./ExercisesIntroducePaus.vue?vue&type=template&id=e9c82fb0"
import script from "./ExercisesIntroducePaus.vue?vue&type=script&lang=js"
export * from "./ExercisesIntroducePaus.vue?vue&type=script&lang=js"
import style0 from "./ExercisesIntroducePaus.vue?vue&type=style&index=0&id=e9c82fb0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports